<template>
  <component :is="currentComponent"></component>
</template>

<script>
import ContentEn from './PrimaryContent/ContentEn.vue';
import ContentPtBR from './PrimaryContent/ContentPtBR.vue';
import ContentEs from './PrimaryContent/ContentEs.vue';
import { LANGUAGES } from '@/common/constants';

export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      if (this.language === LANGUAGES.PT_BR) {
        return ContentPtBR;
      }
      if (this.language === LANGUAGES.ES) {
        return ContentEs;
      }
      return ContentEn;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
